/* eslint-disable */
import React, { ReactNode } from 'react';
import { BreadcrumbsArrayConfiguration } from '../Breadcrumbs/Breadcrumbs';
import BreadcrumbsComponent from '../BreadcrumbsComponent';
import s from './PageTittle.module.scss';

type PageTitleProps = {
  children?: ReactNode | null;
  pageCrumbs: Array<BreadcrumbsArrayConfiguration>;
  pageTitle: string;
  contextElements?: ReactNode | null;
  isTestStatusPassed?: boolean;
  wrapperStyle?: React.CSSProperties;
  tooltipText?: string;
  showTooltip?: boolean;
  customText?: string;
  headerActions?: ReactNode;
  alert?: ReactNode;
  percentage?: number;
};

const PageTitle = ({
  children,
  pageTitle,
  pageCrumbs,
  contextElements,
  isTestStatusPassed,
  wrapperStyle,
  tooltipText,
  showTooltip,
  customText,
  headerActions,
  alert,
  percentage,
}: PageTitleProps) => (
  <div className={`${s.wrapper}`}>
    <div className={s.wrapper__header}>
      <div className={s.wrapper__title}>
        <BreadcrumbsComponent
          isLID={pageTitle === 'LID Dashboard'}
          isTestPassed={isTestStatusPassed}
          titleName={pageTitle}
          crumbs={pageCrumbs}
          wrapperStyle={wrapperStyle}
          tooltipText={tooltipText}
          showTooltip={showTooltip}
          customText={customText}
          percentage={percentage}
        />
      </div>
      {headerActions && (
        <div className={s.wrapper__actions}>{headerActions}</div>
      )}
    </div>
    {alert && <div className={s.wrapper__alert}>{alert}</div>}
    {contextElements !== undefined && (
      <div className={s.wrapper__content}>{contextElements}</div>
    )}
    <div className={s.wrapper__main}>{children}</div>
  </div>
);

export default PageTitle;
